import { type FC } from 'react';

import { BaseIcon, type BaseIconOuterProps } from '@/components/common/icons/BaseIcon';

export const CrossIcon: FC<BaseIconOuterProps> = (props) => {
  return (
    <BaseIcon iconType="stroke" {...props}>
      <path d="M18 6L6 18" />
      <path d="M6 6L18 18" />
    </BaseIcon>
  );
};
